export default Object.freeze({
  // ハリ
  firmness_color_code: "#fc85fe",
  firmness_rgba: "rgba(252,133,254,1)",
  // 乾燥小じわ
  wrinkles_color_code: "#70dc5b",
  wrinkles_rgba: "rgba(112,220,91,1)",
  // 目もとの明るさ
  darkCirclesV2_color_code: "#777b8b",
  darkCirclesV2_rgba: "rgba(119,123,139,1)",
  // 毛穴の目立ち
  pore_color_code: "#8bb810",
  pore_rgba: "rgba(139,184,16,1)",
  // なめらかさ
  texture_color_code: "#cd86f2",
  texture_rgba: "rgba(205,134,242,1)",
  // 肌全体の明るさ
  ageSpots_color_code: "#01c0fe",
  ageSpots_rgba: "rgba(1,192,254,1)",
  // うるおい
  moisture_color_code: "#23d9e3",
  moisture_rgba: "rgba(35,217,227,1)",
});
